<div mat-dialog-title class="dialog-header call-detail-header">
   <h3 class="dialog-title">Call Details</h3>
   @if (true) {
   <div class="nav-buttons">
      <button
         [hidden]="
            !relatedCallDetails ||
            relatedCallDetails?.length === 0 ||
            registerType !== 'account-history' ||
            (!hasNavigateDown && !hasNavigateUp)
         "
         [disabled]="!hasNavigateDown"
         mat-icon-button
         (click)="onNavigateDown()"
      >
         <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <span class="detail-index" [hidden]="!hasNavigateDown && !hasNavigateUp">{{ indexDisplay }}</span>
      <button
         [hidden]="
            !relatedCallDetails ||
            relatedCallDetails?.length === 0 ||
            registerType !== 'account-history' ||
            (!hasNavigateDown && !hasNavigateUp)
         "
         [disabled]="!hasNavigateUp"
         mat-icon-button
         (click)="onNavigateUp()"
      >
         <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
   </div>
   }
   <h4 class="call-date">{{ callLogs.startDate || callLogs.startTime | date : 'MMM d, y, hh:mm:ss aa' }}</h4>
</div>
<mat-dialog-content class="dialog-body mat-dialog-content-no-heading">
   <section class="call-summary-card">
      <div class="summary-grid">
         <div class="summary-item">
            <span class="summary-label">From</span>
            <span class="summary-value">{{ callLogs.callSource | formatPhoneNumbers }}</span>
         </div>
         <div class="summary-item">
            <span class="summary-label">To</span>
            <span class="summary-value">{{ callLogs.callDestination | formatPhoneNumbers }}</span>
         </div>
         <div class="summary-item">
            <span class="summary-label">Dialed</span>
            <span class="summary-value">{{
               (callLogs.callDirectionTypeId == 'Inbound' && callLogs.phoneNumber
                  ? callLogs.phoneNumber
                  : callLogs.originalDestinationNumber
               ) | formatPhoneNumbers
            }}</span>
         </div>
         <div class="summary-item">
            <span class="summary-label">Finished On</span>
            <span class="summary-value">
               {{
                  callSegmentsAndRecording?.callSegmentsConnection?.items?.length > 0 &&
                  callSegmentsAndRecording.callSegmentsConnection.items[
                     callSegmentsAndRecording.callSegmentsConnection.items.length - 1
                  ].extension
                     ? callSegmentsAndRecording.callSegmentsConnection.items[
                          callSegmentsAndRecording.callSegmentsConnection.items.length - 1
                       ].extension.number +
                       ' - ' +
                       callSegmentsAndRecording.callSegmentsConnection.items[
                          callSegmentsAndRecording.callSegmentsConnection.items.length - 1
                       ].extension.name
                     : callLogs.callSegmentsConnection?.items?.length > 0 &&
                       callLogs.callSegmentsConnection.items[callLogs.callSegmentsConnection.items.length - 1].extension
                     ? callLogs.callSegmentsConnection.items[callLogs.callSegmentsConnection.items.length - 1].extension
                          .number +
                       ' - ' +
                       callLogs.callSegmentsConnection.items[callLogs.callSegmentsConnection.items.length - 1].extension
                          .name
                     : callLogs.destinationExtension
                     ? callLogs.destinationExtension.number + ' - ' + callLogs.destinationExtension.name
                     : ''
               }}
            </span>
         </div>
      </div>
   </section>

   @if (isSystemUser) {
   <mat-expansion-panel
      class="technical-details-panel"
      [expanded]="(advancedSectionExpanded$ | async) ?? false"
      (opened)="onAdvancedSectionToggled(true)"
      (closed)="onAdvancedSectionToggled(false)"
   >
      <mat-expansion-panel-header>
         <mat-panel-title><mat-icon class="section-icon">settings</mat-icon>Advanced Details</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="tech-grid">
         <div class="tech-item">
            <span class="tech-label">Server</span>
            <span class="tech-value">{{
               callSegmentsAndRecording?.serverName
                  ? callSegmentsAndRecording.serverName
                  : callLogs.serverName
                  ? callLogs.serverName
                  : 'N/A'
            }}</span>
         </div>
         <div class="tech-item">
            <span class="tech-label">SIP Id</span>
            <span class="tech-value">
               @if (callSegmentsAndRecording?.sipCallId ?? callLogs.sipCallId) {
               <mat-icon
                  class="sip-id-copy-icon"
                  (click)="
                     copySipIdToClipboard(callSegmentsAndRecording?.sipCallId ?? callLogs.sipCallId);
                     $event.preventDefault();
                     $event.stopPropagation()
                  "
                  >content_copy</mat-icon
               >
               }
               {{ callSegmentsAndRecording?.sipCallId ?? callLogs.sipCallId }}
            </span>
         </div>
         <div class="tech-item">
            <span class="tech-label">Provider</span>
            <span class="tech-value">{{ providerDetails }}</span>
         </div>
         <div class="tech-item">
            <span class="tech-label">IP</span>
            <span class="tech-value">{{ ipDetails }}</span>
         </div>
         <div class="tech-item">
            <span class="tech-label">Stir/Shaken</span>
            <span class="tech-value">
               Attest: {{ callSegmentsAndRecording?.stirShakenAttest ?? callLogs?.stirShakenAttest ?? '' }}
               &nbsp;/&nbsp; Verification:
               {{ callSegmentsAndRecording?.stirShakenVerification ?? callLogs?.stirShakenVerification ?? '' }}
            </span>
         </div>
         <div class="tech-item">
            <span class="tech-label">Check call logs on</span>
            <span class="tech-value tech-value-actions">
               <button
                  type="button"
                  mat-button
                  color="primary"
                  class="logo-button add-right-margin"
                  (click)="openLink(graylogSipCallIdLogsLink)"
               >
                  <ndt-graylog-logo class="button-logo-standalone"></ndt-graylog-logo>
                  Graylog
               </button>
               <button
                  type="button"
                  mat-button
                  color="primary"
                  class="logo-button"
                  (click)="openLink(homerSipCallIdLogsLink)"
               >
                  <ndt-homer-logo class="button-logo-standalone"></ndt-homer-logo>
                  Homer
               </button>
            </span>
         </div>
      </div>
   </mat-expansion-panel>
   }

   <section class="segments-section">
      <h5 class="section-heading"><mat-icon class="section-icon">list_alt</mat-icon>Call Segments</h5>
      @if (canShowRecordingFile) {
      <div class="recording-row">
         @if (recordingFile) {
         <lcs-audio-player
            #audioPlayer
            class="recording-audio-player"
            [url]="recordingFile.fileToken | fileUrl"
            [segments]="recordingSegments"
            errorMessage="Failed to load audio file"
            (error)="onFileNotFound($event)"
         ></lcs-audio-player>
         }
      </div>
      }
      <div class="call-segments-table" cdkScrollable>
         <lcs-responsive-table #responsiveTable [columns]="columns">
            <table lcs-table [dataSource]="flattenedRows">
               <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
               <tr lcs-row *lcsResponsiveRowDef="let row" (click)="onRowClick(row)" class="clickable-row"></tr>
               <ng-container lcsColumnDef="expand" [width]="0.2">
                  <th lcs-header-cell *lcsHeaderCellDef></th>
                  <td lcs-cell *lcsCellDef="let row">
                     @if (!row.isDial && row.hasDials){
                     <button
                        type="button"
                        mat-icon-button
                        (click)="onRowClick(row); $event.stopPropagation()"
                        class="example-toggle-button"
                     >
                        <mat-icon>{{ row.isExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                     </button>
                     }
                  </td>
               </ng-container>

               <ng-container lcsColumnDef="Extension" [width]="1.5">
                  <th lcs-header-cell *lcsHeaderCellDef>Extension</th>
                  <td lcs-cell *lcsCellDef="let row">
                     @if (!row.isDial) {
                     {{
                        callLogs.callDirectionTypeId === 'Outbound' && row.sourceExtensionId === row.extensionId
                           ? row.sourceExtension?.number
                           : row.extension?.number
                     }}
                     }
                  </td>
               </ng-container>

               <ng-container lcsColumnDef="Type" [width]="1.75">
                  <th lcs-header-cell *lcsHeaderCellDef>Type</th>
                  <td lcs-cell *lcsCellDef="let row">
                     @if (!row.isDial) {
                     {{
                        callLogs.callDirectionTypeId === 'Outbound' && row.sourceExtension === row.extensionId
                           ? (row.sourceExtension?.extensionType.name | addSpaces)
                           : (row.extension?.extensionType.name | addSpaces)
                     }}
                     }
                  </td>
               </ng-container>

               <ng-container lcsColumnDef="Description" [width]="2.25">
                  <th lcs-header-cell *lcsHeaderCellDef>Description</th>
                  <td lcs-cell *lcsCellDef="let row">
                     @if (!row.isDial) {
                     {{
                        callLogs.callDirectionTypeId === 'Outbound' && row.sourceExtensionId === row.extensionId
                           ? row.sourceExtension?.name
                           : row.extension?.name
                     }}
                     } @else if (row.dial.type === 'agent') {
                     {{ row.dial.agentExtension?.name }} - {{ row.dial.agentExtension?.number }}
                     } @else if (row.dial.type === 'callback') {
                     {{ 'Callback Attempt' }}
                     } @else if (row.dial.type === 'callbackrequested') {
                     {{ 'Callback Request' }}
                     } @else if (row.dial.type === 'callbackrequeued'){
                     {{ 'Callback Accepted' }}
                     }
                  </td>
               </ng-container>

               <ng-container lcsColumnDef="Start Time" [width]="1.5">
                  <th lcs-header-cell *lcsHeaderCellDef>Start Time</th>
                  <td lcs-cell *lcsCellDef="let row">
                     <button
                        type="button"
                        class="segment-time-link"
                        [disabled]="!canSeekToRow(row)"
                        [title]="canSeekToRow(row) ? 'Jump to this point in the recording' : null"
                        (click)="seekRecordingToRow(row); $event.stopPropagation()"
                     >
                        @if (canSeekToRow(row)) {
                        <mat-icon class="segment-time-icon">play_circle</mat-icon>
                        } @if (!row.isDial) {
                        {{ row.startDate | date : 'hh:mm:ss aa' }}
                        } @else {
                        {{ row.dial.dialStartTime | date : 'hh:mm:ss aa' }}
                        }
                     </button>
                  </td>
               </ng-container>

               <ng-container lcsColumnDef="Duration" [width]="1.5">
                  <th class="header-align-right" lcs-header-cell *lcsHeaderCellDef>Duration</th>
                  <td class="text-align-right" lcs-cell *lcsCellDef="let row">
                     @if (row.isDial && (row.dial.type === 'callbackrequested' || row.dial.type === 'callbackrequeued'))
                     {
                     {{ '' }}
                     } @else if (!row.isDial) {
                     {{ row.duration | formatSeconds }}
                     } @else if (row.isDial) {
                     {{ row.dial.duration | formatSeconds }}
                     }
                  </td>
               </ng-container>
               <ng-container lcsColumnDef="alert" [width]="0.6">
                  <th lcs-header-cell *lcsHeaderCellDef></th>
                  <td lcs-cell *lcsCellDef="let row">
                     @if (!row.isDial && row.hasDials && row.hasCallback){
                     <button
                        type="button"
                        mat-button
                        [matMenuTriggerFor]="durationInfo"
                        (click)="$event.stopPropagation()"
                        matTooltip="Info"
                        aria-label="Call Detail Info"
                        id="call-detail-info"
                     >
                        <mat-icon>info</mat-icon>
                     </button>
                     }</td
                  >
               </ng-container>
            </table>
         </lcs-responsive-table>
      </div>
   </section>
</mat-dialog-content>
<mat-dialog-actions>
   @if (!callLogs.endTime && canHangupCalls) {
   <button type="button" mat-stroked-button color="primary" (click)="onHangupActiveCall(callLogs)">Hangup</button>
   }
   <button type="button" mat-raised-button color="primary" (click)="onCloseClick()">Close</button>
</mat-dialog-actions>
<mat-menu #durationInfo="matMenu">
   <div class="duration-text">
      <h5>Segment durations may differ from original call record for calls with queue callbacks</h5>
   </div>
</mat-menu>
